module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-28-96487025d71b9b50484fcfe9b72a65a1.png";